'use client';
import React from 'react';
import Cookies from 'js-cookie';
import { usePathname } from 'next/navigation';
import { UserStatus } from '@/src/lib/customer/types.ts';
import { GetUser } from '@/src/lib/auth/types.ts';
import { ORDER_REFERENCE_COOKIE_NAME } from '@/src/lib/checkout/consts.ts';

function ClientCookiesClient({ userInfo }: { userInfo: GetUser }) {
  const pathname = usePathname();

  if (pathname && !pathname.includes('checkout/success') && !pathname.includes('/confirm')) {
    Cookies.remove(ORDER_REFERENCE_COOKIE_NAME);
  }

  if ([UserStatus.REGISTERED, UserStatus.VERIFIED].includes(userInfo.userStatus)) {
    Cookies.remove('guestId');
  }

  return <></>;
}

export default ClientCookiesClient;
